import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';

import CovidTestsTable from '../parts/CovidTests/CovidTestsTable';
import CovidTestsDialog from '../parts/CovidTests/CovidTestsDialog';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
  addNewButton: {
    marginTop: 20,
    marginBottom: 30,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class CovidTestsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      isDialogOpen: false,
      dialogData: null,
    };

    this.axiosCancel = null;

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onAddNewButtonClick = this.onAddNewButtonClick.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
      dialogData: null,
    });
  }

  onAddNewButtonClick() {
    this.setState({
      isDialogOpen: true,
      dialogData: null,
    });
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    return axios
      .get(
        `${window.apiUrl}/getcovidtests/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.setState({
            data: data,
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      isLoaded,
      isLoading,
      data,
      isDialogOpen,
      dialogData,
    } = this.state;
    const {
      classes,
      t,
      selectedPupil,
    } = this.props;

    return (
      <div className="covid-tests-page">
        <Typography
          className={classes.sectionHeading}
          variant="h5"
          component="h5"
        >
          {t('COVID Tests')}
        </Typography>
        {selectedPupil.can_record_covid_tests && (
          <div>
            <Fab
              size="small"
              variant="extended"
              color="secondary"
              className={classes.addNewButton}
              onClick={this.onAddNewButtonClick}
            >
              {t('Report new COVID test')}
            </Fab>
          </div>
        )}
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {isLoaded && data.length === 0 && (
          <p>{t('You currently have no reported COVID tests')}</p>
        )}
        {isLoaded && data.length > 0 && (
          <CovidTestsTable
            entries={data}
            reloadData={this.reloadData}
            useSuspense={false}
          />
        )}
        <CovidTestsDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={this.onDialogClose}
          reloadData={this.reloadData}
          data={dialogData}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(CovidTestsPage))
);
